module.exports = __webpack_public_path__ + "media/images/application2/AppPublisher__edit__buttons-841d3e97285c3d7bcd637be5d9847503.svg";